export { default as GLOBAL_STORE } from "./storeGlobal";
